const ManageAccess = ({ value, children }) => {
  return value ? children : null;
};

export default ManageAccess;
